$(function(){
    $('.LpWoundsTestimonialsCarousel').owlCarousel({
        loop: true,
        nav: true,
        items: 1,
        navText: [
            '<svg class="icon-chevron-left text-primary"><use xlink:href="#icon-chevron-left"></use></svg>',
            '<svg class="icon-chevron-right text-primary"><use xlink:href="#icon-chevron-right"></use></svg>'
        ],
        dots: false,
        margin: 15,
        responsive: {
            992: {
                items: 3,
                loop: false,
                autoplay: true
            }
        }
    });
});